export const N5221_EFFECTIVE_DATE = "2026-01-01";

export function hasUsableDate(r) {
  return typeof r?.prothesmia === "string" && r.prothesmia.trim() !== "";
}

export function isExcludedFromEidikes(value) {
  const v = value ?? "";
  return (
    v.includes("ΔΙΑΤΑΓ") ||
    v.includes("ΑΝΑΚΟΠ") ||
    v.includes("ΕΝΔΙΚΑ ΜΕΣΑ") ||
    v.includes("ΑΡΕΙΟΥ ΠΑΓΟΥ") ||
    v.includes("ΑΣΦΑΛΙΣΤ") ||
    v.includes("ΕΚΟΥΣΙΑ") ||
    v.includes("ΠΤΩΧΕΥΣ") ||
    v.includes("ΔΙΑΘΗΚ") ||
    v.includes("ΝΟΜΙΚΗ ΒΟΗΘΕΙΑ")
  );
}

export function isEidikesCase(item, katathesiIsoDate) {
  if (!katathesiIsoDate || katathesiIsoDate < N5221_EFFECTIVE_DATE) {
    return false;
  }

  if (item?.eidos?.includes("ΕΦΕΣΗ")) {
    return false;
  }

  const diadikasia = item?.diadikasia ?? "";
  const antikeimeno = item?.antikeimeno ?? "";
  const combined = `${diadikasia} ${antikeimeno}`;

  if (isExcludedFromEidikes(combined)) {
    return false;
  }

  return (
    combined.includes("ΕΙΔΙΚ") ||
    combined.includes("ΠΕΡΙΟΥΣΙΑΚΕΣ ΔΙΑΦΟΡΕΣ") ||
    combined.includes("ΟΙΚΟΓΕΝΕΙΑΚ") ||
    combined.includes("ΕΡΓΑΤΙΚ") ||
    combined.includes("ΜΙΣΘΩΣ") ||
    combined.includes("ΑΥΤΟΚΙΝΗΤ")
  );
}
